<template>
  <dialog-scroll
    :title="title | uppercase"
    :isLoading="isLoading"
    :customClass="customClass"
    ref="dialog"
    append-to-body
    @close="handlerClose">
    <template v-slot:default>
      <slot></slot>
    </template>
    <template v-slot:footer>
      <div>
        <button
          type="button"
          class="btn btn-control btn-border grey btn-size-s"
          @click.prevent="hide"
        >
          {{L10n('cancel')}}
        </button>
      </div>
    </template>
  </dialog-scroll>
</template>

<script>
export default {
  name: 'DialogInfo',
  props: {
    isLoading: { type: Boolean, default: false },
    title: { type: [String, Number] },
    customClass: { type: String, default: '' }
  },
  components: {
    'dialog-scroll': () => import(/* webpackChunkName: 'Dialogs' */ './DialogScroll')
  },
  methods: {
    show (data, callback) {
      this.$refs['dialog'].show()
    },
    hide () {
      this.$refs['dialog'].hide()
    },
    handlerClose () {
      this.$emit('close')
    }
  }
}
</script>
<style lang="stylus">
  .info-footer {
    &>button{
      margin 0 .4rem
    }
  }
</style>
